import { computed, effect, inject, Injectable, signal, Signal, untracked, WritableSignal } from '@angular/core';
import { GroupAssignedAmenity } from '@models/interfaces/amenities/AmenityGroupAssigned.interface';
import { AmenitiesService } from '@services/amenities.service';
import { LayoutService } from './layout.service';
import { BottomSheetService } from './components/bottom-sheet.service';
import { MenuService } from '@services/components/menu.service';
import { BenefitsContainerComponent } from '@components/minisite/topbar/benefits/benefits-container/benefits-container.component';

@Injectable()
export class BenefitsService {

  // SERVICES
  private readonly ams:         AmenitiesService   = inject(AmenitiesService);
  private readonly bottomSheet: BottomSheetService = inject(BottomSheetService);
  private readonly menu:        MenuService        = inject(MenuService);
  
  // GLOBAL STATE
  private readonly isMobile:    Signal<boolean>    = inject(LayoutService).isMobile;

  // COMPONENT STATE
  public  readonly amenities:     Signal<GroupAssignedAmenity[]> = computed((): GroupAssignedAmenity[] => this.ams.selectedAmenities());
  public  readonly showButton:    Signal<boolean>                = computed((): boolean => this.amenities().length !== 0);
  public  readonly showContainer: WritableSignal<boolean>        = signal(false);
  public  readonly isAnimating:   WritableSignal<boolean>        = signal(false);
  
  // METHODS
  public toggleContainer(): void {

    this.showContainer.update((value: boolean): boolean => !value);

    if(this.isMobile() && this.showContainer()){
      this.bottomSheet.open(BenefitsContainerComponent).close.subscribe((): void => this.showContainer.set(false));
      return;
    }

  }

  onAmenitySelected = effect(():void =>{
    if(untracked(this.isMobile)) return;
    if(this.amenities().length){
      this.showContainer.set(true);
    }else if(this.showContainer()){
      this.showContainer.set(false);
    }
  })

  // Al abrir benefits, cerramos el menu. only one can be open at a time
  onBenefitsOpened = effect((): void => {
    if(untracked(this.isMobile)) return;
    if(!this.showContainer()) return;
    untracked((): void => {
      if(this.menu.showContainer()) this.menu.closeMenuContainer();
    });
  })

  // Al abrir el menu, cerramos benefits.
  onMenuOpened = effect((): void => {
    if(untracked(this.isMobile)) return;
    if(!this.menu.showContainer()) return;
    untracked((): void => {
      if(this.showContainer()) this.showContainer.set(false);
    });
  })

}
